import { afterRender, ChangeDetectionStrategy, Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mp-autocomplete-dropdown',
  imports: [
    CommonModule
  ],
  templateUrl: './mp-autocomplete-dropdown.component.html',
  styleUrls: ['./mp-autocomplete-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpAutocompleteDropdownComponent {

  @ViewChild('dropdown', { read: ElementRef, static: false }) dropdownElementRef: ElementRef;

  constructor(private readonly ngZone: NgZone) {
    afterRender({ write: () => this.computePosition() });
  }

  @Input({ required: true }) anchor: ElementRef;

  private computePosition() {
    this.ngZone.runOutsideAngular(() => {
      const { bottom, width, height } = this.anchor.nativeElement.getBoundingClientRect();
      this.dropdownElementRef.nativeElement.style.width = `${width - 2}px`;
      const maxHeight = window.innerHeight;
      const dropDownMeasure = this.dropdownElementRef?.nativeElement?.getBoundingClientRect();

      const translateX = -width;
      let translateY: number;

      if (bottom + dropDownMeasure.height > maxHeight - 10) {
        translateY = -dropDownMeasure.height + 1;
      } else {
        translateY = height - 1;
      }

      this.dropdownElementRef.nativeElement.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`;
    });
  }
}
